module.exports = __webpack_public_path__ + "zyro-mwf.png?f55748ddff4291df0493afb8d0627351";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newsenviromental/zyro-mwf.png
// module id = 317
// module chunks = 0